module.exports = __webpack_public_path__ + "img/normally_open_contact.efc8a8a4.svg";